export const SigningModalType = {
    identification: {
        name: 'IdentificationModal',
        modalClass: 'identification-modal'
    },
    signUp: {
        name: 'SignUpModal',
        modalClass: 'sign-up-modal'
    },
    socialSignUp: {
        name: 'SocialSignUpModal',
        modalClass: 'social-sign-up-modal'
    },
    businessSocialSignUp: {
        name: 'BusinessSocialSignUpModal',
        modalClass: 'business-social-sign-up-modal'
    },
    signIn: {
        name: 'SignInModal',
        modalClass: 'sign-in-modal'
    },
    resetPasswordRequest: {
        name: 'ResetPasswordRequestModal',
        modalClass: 'reset-password-request-modal'
    },
    businessResetPasswordRequest: {
        name: 'BusinessResetPasswordRequestModal',
        modalClass: 'business-reset-password-request-modal'
    }
};
